<template>
    <div>
        <div style="padding-bottom: 11px; padding-top: 11px;" class="vfairs-list">
            <div v-for="i in 3" :key="i">
                <div class="vfairs-item">
                    <div class="square skeleton-loading"></div>
                </div>
            </div>
        </div>
        <Divider />
    </div>
</template>

<script>
export default {
    name: 'VFairListSkeleton',
    props: {
        rows: {
            type: Number,
            default: 4,
        },
        mini: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
.vfairs-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 15px;
}
.vfairs-item {
    display: grid;
    grid-template-rows: repeat(auto);
    grid-template-columns: 1fr;
    grid-auto-flow: row;
    grid-column-gap: 1rem;
    grid-row-gap: 0.2rem;
    text-align: center;
    min-height: 160px;
    background-color: rgba(255, 255, 255, 0.3);
}
.square {
    width: 100%;
    height: 75px;
    border-radius: var(--border-radius);
    background-color: rgb(230, 230, 230);
}
</style>

<style>
.skeleton-loading {
    position: relative;
    overflow: hidden;
}

.skeleton-loading::after {
    display: block;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    transform: translateX(-100%);

    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.45), transparent);
    animation: skeleton-loading 1.4s infinite;
}

@keyframes skeleton-loading {
    100% {
        transform: translateX(100%);
    }
}
</style>
